
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.513 3.538H16.07V2.445c0-.354-.385-.514-.739-.514h-1.896C12.985.645 11.86.002 10.575.002a2.925 2.925 0 00-2.861 1.929H5.85c-.354 0-.707.16-.707.514v1.093H2.7A2.732 2.732 0 000 6.14v18.416C0 25.972 1.286 27 2.7 27h15.813c1.414 0 2.7-1.029 2.7-2.443V6.141a2.732 2.732 0 00-2.7-2.603zM6.428 3.216h1.768a.707.707 0 00.61-.578 1.864 1.864 0 011.768-1.447 1.832 1.832 0 011.736 1.447.707.707 0 00.643.578h1.832v2.571H6.428v-2.57zm13.5 21.341c0 .707-.708 1.157-1.415 1.157H2.7c-.707 0-1.414-.45-1.414-1.157V6.141A1.446 1.446 0 012.7 4.823h2.442v1.64c.034.36.346.629.708.61h9.48c.369.02.69-.246.74-.61v-1.64h2.443a1.446 1.446 0 011.414 1.318v18.416z"}}),_c('path',{attrs:{"d":"M8.132 14.369a.643.643 0 00-.9-.032l-2.057 1.96-.868-.9a.643.643 0 00-.9-.032.675.675 0 000 .932l1.318 1.35a.578.578 0 00.45.193.643.643 0 00.45-.193l2.507-2.378a.61.61 0 000-.9z","fill":"#F9BC39"}}),_c('path',{attrs:{"d":"M17.356 15.75H9.964a.643.643 0 100 1.287h7.392a.643.643 0 000-1.286zM8.132 9.226a.643.643 0 00-.9-.032l-2.057 1.96-.868-.9a.643.643 0 00-.9-.031.675.675 0 000 .932l1.318 1.35a.578.578 0 00.45.193.642.642 0 00.45-.193l2.507-2.379a.61.61 0 000-.9zM17.356 10.608H9.964a.643.643 0 100 1.286h7.392a.643.643 0 000-1.286zM8.132 19.511a.643.643 0 00-.9-.032l-2.057 1.96-.868-.9a.643.643 0 00-.9-.031.675.675 0 000 .932l1.318 1.35a.578.578 0 00.45.192.643.643 0 00.45-.192l2.507-2.379a.61.61 0 000-.9zM17.356 20.893H9.964a.643.643 0 100 1.286h7.392a.643.643 0 000-1.286z"}})])
          )
        }
      }
    